// extracted by css-extract-rspack-plugin
export default {"wrapper":"_e9c25a8c","title":"_5b64e25f","tagIcon":"_4abac926","links":"_2fe5eeec"};